import React from "react";
import { NavbarBrand, Nav, NavItem, NavLink } from "reactstrap";
import { BiPhoneCall } from "react-icons/bi";
import { HiOutlineLocationMarker, HiOutlineMail } from "react-icons/hi";
import "./style.css";

function Footer() {
  return (
    <div className="bg_footer py-5">
      <div className="container mx-auto">
        <div className="row">
          <div className="col-4">
            <NavbarBrand href="/" className="img_logo_footer">
              {" "}
              Cosmetics{" "}
            </NavbarBrand>

            <nav className="mt-4">
              <ul>
                <li className="d-flex align-items-center mb-3">
                  <HiOutlineLocationMarker className="t-primary me-2" />

                  <p>
                    Address:{" "}
                    <span className="t-grey">
                      97 Man Thien, Hiep Phu, TP. Thu Duc
                    </span>
                  </p>
                </li>

                <li className="d-flex align-items-center mb-3">
                  <BiPhoneCall className="t-primary me-2" />
                  <p>
                    Phone: <span className="t-grey">0123456789</span>
                  </p>
                </li>

                <li className="d-flex align-items-center">
                  <HiOutlineMail className="t-primary me-2" />
                  <p>
                    Email: <span className="t-grey">abcde@gmail.com</span>
                  </p>
                </li>
              </ul>
            </nav>
          </div>

          <div className="col-8 mt-2">
            <div className="row">
              <div className="col-3 text-end">
                <p className="mb-4 fs-5 fw-bolder">About</p>

                <Nav vertical>
                  <NavItem>
                    <NavLink href="/">Terms of Service</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="/">Terms & Condition</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="/">Terms of Delivery</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="/">Delivery Information</NavLink>
                  </NavItem>
                </Nav>
              </div>

              <div className="col-3 text-end">
                <p className="mb-4 fs-5 fw-bolder">Infomation</p>

                <Nav vertical>
                  <NavItem>
                    <NavLink href="/">About Us</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="/">Contact Us</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="/">Privacy Policy</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="/">Shipping Details</NavLink>
                  </NavItem>
                </Nav>
              </div>

              <div className="col-3 text-end">
                <p className="mb-4 fs-5 fw-bolder">Support</p>

                <Nav vertical>
                  <NavItem>
                    <NavLink href="/">News</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="/">Contact</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="/">E-mail Support</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="/">Chat Support</NavLink>
                  </NavItem>
                </Nav>
              </div>

              <div className="col-3 text-end">
                <p className="mb-4 fs-5 fw-bolder">Help</p>

                <Nav vertical>
                  <NavItem>
                    <NavLink href="/">FAQ</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="/">Catalog</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="/">Search</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="/">Wishlist</NavLink>
                  </NavItem>
                </Nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
